<style src="./TaskResult.scss" lang="scss" scoped></style>
<template>
  <div
    v-show="!!result && result.totalGlobal"
    class="task-result">
    <span class="result">
      {{ result && result.totalGlobal }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TaskResult',
  props: {
    result: {
      default: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/task-result/TaskResult.vue